import './App.css';
import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import CreateVenue from './components/admin/CreateVenue';
import Sidebar from './components/admin/Sidebar';
import ListVenue from './components/admin/ListVenue';
import ListAddon from './components/admin/addon/ListAddon';
import CreateAddon from './components/admin/addon/CreateAddon';
import Dashboard from './components/admin/dashboard/Dashboard';
import TransactionList from './components/admin/transaction/TransactionList';
import TransactionDetail from './components/admin/transaction/TransactionDetail';
import VenueSchedule from './components/admin/schedule/VenueSchedule';
import Login from './components/admin/user/Login';
import Registration from './components/admin/user/Registration';
import ForgotPassword from './components/admin/user/ForgotPassword';
import Company from './components/admin/user/Company';
import Settlement from './components/admin/user/Settlement';
import Checkout from './components/admin/checkout/Checkout';
import { AppStateProvider, useAppState } from './AppStateContext';
import { NavLink, useNavigate } from 'react-router-dom';


const ProtectedRoutes = () => (
  <Routes>
    {/* <Route path='/' element={<Dashboard />} /> */}
    <Route path='/transaction' element={<TransactionList />} />
    <Route path='/transaction/:trxId' element={<TransactionDetail />} />
    <Route path='/settlement' element={<Settlement />} />
    <Route path='/venue' element={<CreateVenue />} />
    <Route path='/addon' element={<ListAddon />} />
    <Route path='/addon/create' element={<CreateAddon />} />
    <Route path='/addon/edit/:addOnId' element={<CreateAddon editMode={true} />} />
    {/* <Route path='/venue/list' element={<ListVenue />} /> */}
    <Route path='/' element={<ListVenue />} />
    <Route path='/venue/schedule/:venueId' element={<VenueSchedule />} />
    <Route path='/venue/edit/:venueId' element={<CreateVenue action="edit" />} />
    <Route path='/pengaturan' element={<Company />} />
  </Routes>
);

const AppContent = () => {

  let { user, updateUser } = useAppState();
  const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const storedUser = localStorage.getItem("user");
  //   if (storedUser) {
  //     updateUser(JSON.parse(storedUser));
  //   }
  //   setLoading(false);
  // }, [updateUser]);

  // if (loading) {
  //   return <div></div>;
  // }

  return (
    <div className={`background-header flex w-full ${user === null ? 'lg:h-screen lg:items-center lg:justify-center' : ''}`}>
      <div className={`flex ${user === null ? 'w-[500px] mt-20 ml-4 mr-4 mb-8' : 'flex-1 mt-40 lg:mx-20 mb-20 print:mt-0'} bg-white rounded-xl`}>
        <Toaster />
        {user !== null && <div className='w-[340px] print:hidden'><Sidebar /></div>}
        <div className='flex flex-col w-full'>

          <div className='flex flex-row w-full hidden print:flex mt-8'>
            <img src='/logo_fityuk.webp' className='w-[250px] h-auto' />

            <div className="flex flex-grow" />
            <div className='ml-4 flex items-center text-2xl font-bold'>
              apps.fityuk.com
            </div>
          </div>
          <Routes>
            <Route path='/login' element={user !== null ? <Navigate to="/" /> : <Login />} />
            <Route path='/registration' element={user !== null ? <Navigate to="/" /> : <Registration />} />
            <Route path='/forgot_password' element={user !== null ? <Navigate to="/" /> : <ForgotPassword />} />
            <Route path='/checkout' element={<Checkout />} />
            <Route
              path='/*'
              element={user !== null ? <ProtectedRoutes /> : <Navigate to="/login" />}
            />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default function App() {
  return (
    <AppStateProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AppStateProvider>
  );
}
